import * as types from '../constants/ActionTypes';

export const addConfig = (config) => ({
  type: types.ADD_CONFIG,
  config,
});

// export const addToken = (token) => ({
//   type: types.ADD_TOKEN,
//   token,
// });

export const changePatientToAnonym = () => ({
  type: types.CHANGE_ANONYM,
});
